"use client";
import {
  createDisclosureStore
} from "./WCKXDMU7.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
